import { render } from "./HeaderComponent.vue?vue&type=template&id=47493c74&scoped=true"
const script = {}

import "./HeaderComponent.vue?vue&type=style&index=0&id=47493c74&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-47493c74"]])

export default __exports__